document.addEventListener('DOMContentLoaded', () => {
  const headerElement = document.querySelector('.header');
  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(megaMenu => {
    megaMenu.addEventListener('toggle', (event) => {
      if (event.target.hasAttribute('open')) {
        headerElement.classList.add('wknd_mega-menu-open');
      } else {
        headerElement.classList.remove('wknd_mega-menu-open');
      }
    });
  });
});

// Mobile Touch Image Switcher
document.addEventListener('DOMContentLoaded', function() {
  ////console.log('Script loaded');
  
  // Only run on mobile devices
  if (window.innerWidth <= 768) {
    //console.log('Mobile device detected');
    const productCards = document.querySelectorAll('.wknd-product-card-wrapper');
    //console.log('Found ' + productCards.length + ' product cards');
    
    productCards.forEach((card, index) => {
      //console.log('Processing card #' + index);
      const media = card.querySelector('.media.media--hover-effect');
      if (!media) {
        //console.log('Card #' + index + ' has no media element');
        return;
      }
      
      const images = media.querySelectorAll('img');
      //console.log('Card #' + index + ' has ' + images.length + ' images');
      
      // Check if we have at least 2 images
      if (images.length >= 2) {
        //console.log('Card #' + index + ' has multiple images, setting up touch events');
        
        // Add touch event listeners to the product card
        card.addEventListener('touchstart', function() {
          //console.log('Touch started on card #' + index);
          images[1].style.opacity = '1';
        });
        
        card.addEventListener('touchend', function() {
          //console.log('Touch ended on card #' + index);
          images[1].style.opacity = '0';
        });
      }
    });
  } else {
    //console.log('Not a mobile device, script not applied');
  }
});

// document.addEventListener('click', function(event) {
//   // Check if click is outside the menu drawer inner container
//   const menuDrawerInner = document.querySelector('.menu-drawer__inner-container');
//   const menuDrawerContainer = document.querySelector('.menu-drawer-container');
//   const headerIcon = document.querySelector('.header__icon[aria-controls="menu-drawer"]');
  
//   if (menuDrawerInner && !menuDrawerInner.contains(event.target) && 
//       !event.target.closest('.header__icon[aria-controls="menu-drawer"]')) {
    
//     // Update the header icon aria-expanded attribute
//     if (headerIcon) {
//       headerIcon.setAttribute('aria-expanded', 'false');
//     }
    
//     // Remove classes and attributes from the menu drawer container
//     if (menuDrawerContainer) {
//       menuDrawerContainer.classList.remove('menu-opening');
//       menuDrawerContainer.removeAttribute('open');
//     }
//   }
// });